export default {
    ENTER_KEY: 'Enter',
    MAX_DIFF_TIME_WITH_SCAN_BARCODE: 100,
    BARCODE_CONFIG: 'webpos/product_search/barcode',
    ADDITIONAL_ATTRIBUTES_ON_GRID_CONFIG: 'webpos/product_search/additional_attributes_on_grid',
}



// WEBPACK FOOTER //
// ./src/view/constant/SearchConstant.js